import React from 'react'

export function NotFoundPage() {
  return (
    <div className="text-center" style={{paddingTop: '100px'}}>
      <h3>Sorry, page not found!</h3>
    </div>
  )
}
